// utils/logoutUser.js

import { BASE_URL } from "../../../env_config";


export function Logoutuser() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('persist:suppAuthTemp');
    window.location.replace(`${BASE_URL}/logout`);
  }
  